var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-container"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/ksxg/tixing.png")}})])])
}]

export { render, staticRenderFns }